'use strict';

export default class Header {
  constructor() {
    this.initSearch();
    this.mobileNavigation();
  }

  initSearch() {
    $(".site-header__search").on('click', (e) => {
      // e.preventDefault();
      $(".site-header__search").toggleClass("active");
    });

    $(".site-header__search").on('click', '.region--search', (e) => {
      e.stopPropagation();
    });
  }

  mobileNavigation() {
    $(".mobile-buttons").on('click', '.mobile-nav-button', function(e) {
      e.preventDefault();
      console.log("Here tryimg tp add trigger button");
      $(this).closest(".mobile-buttons").toggleClass("active");
      $('body').toggleClass("menu-opened");
      $(".menu--level-1 > .menu__item.menu__item--has-children .submenu-trigger").remove();
      $(".menu--level-1 > .menu__item.menu__item--has-children").append("<div class='submenu-trigger'></div>");
      // console.log("Here tryimg tp add trigger button");
    });

    // children menu
    $("body").on('click', '.submenu-trigger', function(e) {
      // console.log($(this).sibling(".menu"));
      let menuItem = $(this).closest(".menu__item");
      let parentLink = menuItem.find(">.menu__link").html();
      let childMenu = menuItem.find("> .menu");
      childMenu.find(".back").remove();
      childMenu.prepend(`<li class='menu__header back flex justify-space-between gap-small items-center'>
        <span class='text-lg leading-6 font-normal'><i class='icon-caret-left'></i> Main menu</span>
        <span class='text-xl leading-5 font-bold menu__header-parent'>${parentLink}</span>
      </li>`);
      childMenu.addClass("active");
    });

    $("body").on('click', '.back', function(e) {
      e.stopPropagation();
      $(this).closest(".menu").removeClass("active");
    });

    
  }
}
